var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCouriers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18.75H2C1.60218 18.75 1.22064 18.592 0.93934 18.3107C0.658035 18.0294 0.5 17.6478 0.5 17.25V6.75C0.5 6.35218 0.658035 5.97064 0.93934 5.68934C1.22064 5.40804 1.60218 5.25 2 5.25H17C17.3978 5.25 17.7794 5.40804 18.0607 5.68934C18.342 5.97064 18.5 6.35218 18.5 6.75V9.75",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.65L15.2 1.42C15.0678 1.22078 14.89 1.05602 14.6812 0.939478C14.4725 0.822932 14.2389 0.757968 14 0.75H5.05C4.80255 0.749908 4.55891 0.811036 4.34081 0.927937C4.12271 1.04484 3.93692 1.21388 3.8 1.42L1 5.65",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.75V5.25",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79 21.75H8C7.60218 21.75 7.22064 21.592 6.93934 21.3107C6.65804 21.0294 6.5 20.6478 6.5 20.25V14.25C6.5 13.8522 6.65804 13.4706 6.93934 13.1893C7.22064 12.908 7.60218 12.75 8 12.75H16C16.3978 12.75 16.7794 12.908 17.0607 13.1893C17.342 13.4706 17.5 13.8522 17.5 14.25V19.72",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.25H20.5C21.2956 14.25 22.0587 14.5661 22.6213 15.1287C23.1839 15.6913 23.5 16.4544 23.5 17.25V20.25C23.5 20.6478 23.342 21.0294 23.0607 21.3107C22.7794 21.592 22.3978 21.75 22 21.75H20.21",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.37 23.24C19.4028 23.24 20.24 22.4028 20.24 21.37C20.24 20.3372 19.4028 19.5 18.37 19.5C17.3372 19.5 16.5 20.3372 16.5 21.37C16.5 22.4028 17.3372 23.24 18.37 23.24Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.62 23.24C11.6528 23.24 12.49 22.4028 12.49 21.37C12.49 20.3372 11.6528 19.5 10.62 19.5C9.58723 19.5 8.75 20.3372 8.75 21.37C8.75 22.4028 9.58723 23.24 10.62 23.24Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54 21.75H12.46",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouriers);
export default __webpack_public_path__ + "static/media/couriers.357309bfe3ac02d93b9283940971cb1c.svg";
export { ForwardRef as ReactComponent };